import { queryOptions } from '@tanstack/react-query';
import { ApiError } from '~/components/Providers/APIClient';
import { apiQueryFn } from '../utils';
import { mergeRequestsParamsType } from '~/routes/_authenticated/staff/_mergesLayout/merges/index/-SearchParams';
import { MergeRequest, MergeResponse } from '~/util/types/merges';

export const mergesQuery = ({
    page,
    per_page,
    status,
}: mergeRequestsParamsType) =>
    queryOptions<MergeResponse, ApiError>({
        queryKey: ['merges', page, per_page, status],
        queryFn: apiQueryFn<MergeResponse>({
            path: `/users/merge/requests`,
            method: 'GET',
            query: {
                page,
                per_page,
                claimed_filter:
                    status === 'Claimed'
                        ? true
                        : status === 'Pending'
                          ? false
                          : undefined,
                rejected_filter:
                    status === 'Denied'
                        ? true
                        : status === 'Pending'
                          ? false
                          : undefined,
            },
            attachAuth: true,
        }),
    });

export const mergeQuery = ({ requestid }: { requestid: string }) =>
    queryOptions<MergeRequest, ApiError>({
        queryKey: ['merges', requestid],
        queryFn: apiQueryFn<MergeRequest>({
            path: `/users/merge/requests/${requestid}`,
            method: 'GET',
            attachAuth: true,
        }),
    });
